import { useLocation, Navigate } from 'react-router-dom';
import UserContext from '@lib/contexts/userContext';
import { useContext } from 'react';

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const { isLoggedIn, authenticating } = useContext(UserContext);

  if (!authenticating && !isLoggedIn(false)) {
    console.log('[RequireAuth] User not logged in. Redirecting to login...');
    return <Navigate to="/login" state={{ from: location, redirect: location.pathname }} replace />;
  }
  return children;
}

export default RequireAuth;
